import { render, staticRenderFns } from "./templateDetail.vue?vue&type=template&id=cd2edc1e&scoped=true"
import script from "./templateDetail.vue?vue&type=script&lang=js"
export * from "./templateDetail.vue?vue&type=script&lang=js"
import style0 from "./templateDetail.vue?vue&type=style&index=0&id=cd2edc1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2edc1e",
  null
  
)

export default component.exports